import getScenarioStore from '../selectors/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import { lazyRemoveSuggestionPillFromSearchBox } from 'owa-search';
import { orchestrator } from 'satcheljs';
import {
    onBackspacePressedSearchInput,
    setSelectedSuggestionIndex,
    removeSuggestionSegmentFromSearchBox,
} from '../actions/internalActions';

export default orchestrator(onBackspacePressedSearchInput, async actionMessage => {
    const scenarioId = actionMessage.scenarioId;
    const store = getScenarioStore(scenarioId);

    /**
     * If the cursor is at the beginning of the search input, then delete the
     * last pill.
     */
    if (actionMessage.cursorPosition === 0) {
        const suggestionPillsCount = store.suggestionPillIds.length;
        const suggestionSegmentsCount = store.suggestionSegments.size;

        if (suggestionPillsCount > 0) {
            // Dispatch action to remove last suggestion pill from store.
            const removeSuggestionPillFromSearchBox = await lazyRemoveSuggestionPillFromSearchBox.import();
            removeSuggestionPillFromSearchBox(
                store.suggestionPillIds[suggestionPillsCount - 1],
                scenarioId,
                'BackspaceInput'
            );
        }

        /**
         * Because we can't have segments AND client-side pills right now,
         * this can be a separate block without any repercussions.
         */
        if (suggestionSegmentsCount > 0) {
            // Dispatch action to remove last segment from store.
            const suggestionSegmentKeys = [...store.suggestionSegments.keys()];
            const lastSegmentKey = suggestionSegmentKeys[suggestionSegmentKeys.length - 1];
            removeSuggestionSegmentFromSearchBox(lastSegmentKey, scenarioId);
        }
    }

    // Reset selectedSuggestionIndex because user broke out of navigation flow.
    setSelectedSuggestionIndex(createDefaultSearchStore().selectedSuggestionIndex, scenarioId);
});
